var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDivider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 571.11 45.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f49e8b;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M293.23,22.66c.85-1,4.16-4.5,5.22-8.08C300,9.44,300.05.42,298.15,0c-2.89-.58-6.86,6.38-11.35,13.3-2.87,4.44-5.65,7.24-8.52,10.6-1.76,2-1.34,5.89-1.49,6.91,0,.14-.26.09-.31-.06a30.09,30.09,0,0,1-.82-3.16.19.19,0,0,0-.34-.07,22,22,0,0,0-1.75,2.7C271.5,34.13,271,40.39,272,43.32A116.44,116.44,0,0,0,294.43,9.9c.09-.22.4-.07.33.16-3.48,11.32-12.21,25.41-20.61,35,3.05.14,9.9-2.84,18.87-16.73A34.87,34.87,0,0,0,296.16,22a.19.19,0,0,0-.26-.23c-1,.54-1.93.93-2.48,1.16A.15.15,0,0,1,293.23,22.66Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 21.39,
    width: 265.7,
    height: 2.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 305.41,
    y: 21.39,
    width: 265.7,
    height: 2.28
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivider);
export default __webpack_public_path__ + "static/media/divider.1d5a5bdd0ae03a344a34964d7cc684d8.svg";
export { ForwardRef as ReactComponent };